import "./wdyr";
import "./index.css";
import ReactDOM from "react-dom";
import App from "./App";
import "./i18n";
//  Provider 用於提供專案 Redux 狀態管理
import { Provider } from "react-redux";
//  引入定義好的 store 讓 Redux 可全局狀態管理
import { store } from "./store/store";

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  // 渲染程式的主要元件
  document.getElementById("root")
);
